import { RemoteDataTable } from '@common/components/table';
import { HospitalScheduleTemplateListingModel } from '@common/models';
import { HospitalScheduleTemplateSearchStore } from '@hospital/stores';
import { observer } from "mobx-react";
import React from 'react';
import { TableColumn } from 'react-data-table-component';

export type LocationScheduleTemplateTableProps = {
    templateSearchStore: HospitalScheduleTemplateSearchStore,
    onUpdateCreateSchedulePreference: (templateListingModel: HospitalScheduleTemplateListingModel, e: React.MouseEvent<Element, MouseEvent>) => void

}

const createDataTableColumns = (props: Pick<LocationScheduleTemplateTableProps, "onUpdateCreateSchedulePreference">): TableColumn<HospitalScheduleTemplateListingModel>[] =>
    [
        {
            name: "NAME",
            grow: 2,
            sortField: "name",
            selector: (row: HospitalScheduleTemplateListingModel) => row.name ?? '',
            sortable: true
        },
        {
            name: "COLOR",
            grow: 2,
            sortField: "color",
            selector: (row: HospitalScheduleTemplateListingModel) => row.color ?? '',
            sortable: true,
            cell: row => (<span><span className="color-dot" style={{ backgroundColor: row.color }} /> {row.color}</span>)
        },
        {
            name: "ACTIVE",
            grow: 1,
            sortField: "isActive",
            selector: (row: HospitalScheduleTemplateListingModel) => row.isActive ? 'Yes' : 'No',
            sortable: true,
            cell: row => (<input type="checkbox" className="form-check-input" checked={row.isActive} disabled />)
        },
        {
            name: "PRIMARY",
            grow: 1,
            sortField: "isDefault",
            selector: (row: HospitalScheduleTemplateListingModel) => row.isDefault ? 'Yes' : 'No',
            sortable: true,
            cell: row => (<input type="checkbox" className="form-check-input" checked={row.isDefault} disabled />)
        },
        {
            name: "ACTION",
            grow: 3,
            sortable: false,
            cell: row => (
                <i className="cursor-pointer fa fa-pencil" onClick={(e: React.MouseEvent<Element, MouseEvent>) => props.onUpdateCreateSchedulePreference(row, e)} />
            )
        },

    ];




export const LocationScheduleTemplateTable = observer(({ templateSearchStore, onUpdateCreateSchedulePreference }: LocationScheduleTemplateTableProps) => {
    const [scheduleTemplateColumns] = React.useState<TableColumn<HospitalScheduleTemplateListingModel>[]>(createDataTableColumns({ onUpdateCreateSchedulePreference }));

    return (<RemoteDataTable
        columns={scheduleTemplateColumns}
        searchResult={templateSearchStore.searchResults}
        defaultSortAsc
        defaultSortFieldId={1}
        onSort={templateSearchStore.updateRemoteDTSort}
        pagination={true}
        onRowClicked={onUpdateCreateSchedulePreference}
        onChangePage={(page: number) => { templateSearchStore.changePage(page) }}
        onChangeRowsPerPage={(rowsPerPage: number) => { templateSearchStore.updateSearchParams({ top: rowsPerPage }) }}
        paginationPerPage={templateSearchStore.searchParams.top}
        sortServer={true}
        paginationServer={true}
        noDataComponent={<p>The current hospital does not have any Schedule Templates</p>}
    />);

});
